// extracted by mini-css-extract-plugin
export default {"p_content":"_66b1d2207b"};